import Moment from "moment";

export const validatePhone = phone => {
  const filter = /^\d{8,11}$|^$/;

  if (filter.test(phone)) {
    return true;
  }

  return false;
};

export const validateDate = date => {
  if (Moment(date, "DD/MM/YYYY").isValid()) {
    return true;
  }

  return false;
};

export const validateHour = hour => {
  if (Moment(hour, "HH:mm").isValid()) {
    return true;
  }

  return false;
};

export const validateDatetime = datetime => {
  if (Moment(datetime, "DD/MM/YYYY HH:mm").isValid()) {
    return true;
  }

  return false;
};

export const validateCustomized = (form, config) => {
  let error = {};
  let success = true;

  const keys = Object.keys(form);
  let index = 0;

  config.map(field => {
    if (!!form[field.uuid]) {
      if (
        field.type === "phone" &&
        !validatePhone(form[field.uuid]) &&
        keys[index] === field.uuid
      ) {
        error[field.uuid] = "Telefone com formato inválido.";
        success = false;
        index++;
      } else if (
        field.type === "date" &&
        !validateDate(form[field.uuid]) &&
        keys[index] === field.uuid
      ) {
        error[field.uuid] = "Data com formato inválido.";
        success = false;
        index++;
      } else if (
        field.type === "hour" &&
        !validateHour(form[field.uuid]) &&
        keys[index] === field.uuid
      ) {
        error[field.uuid] = "Hora com formato inválido.";
        success = false;
        index++;
      } else if (
        field.type === "datetime" &&
        !validateDatetime(form[field.uuid]) &&
        keys[index] === field.uuid
      ) {
        error[field.uuid] = "Data e Hora com formato inválido.";
        success = false;
        index++;
      } else {
        error[field.uuid] = "";
        index++;
      }
    }

    return { success, error };
  });

  return { success, error };
};



// WEBPACK FOOTER //
// ./src/util/validate-customized.js